import moment from 'moment';

/**
 * Obtiene el badge de vencimiento para una actividad basado en su fecha de vencimiento
 * @param {string} fechaVencimiento - Fecha de vencimiento en formato ISO
 * @returns {Object} { label: string, variant: string, color: string, categoria: string }
 */
export const getBadgeVencimiento = (fechaVencimiento) => {
  if (!fechaVencimiento) {
    return {
      label: 'Sin fecha',
      variant: 'secondary',
      color: '#6c757d',
      categoria: 'sin_fecha'
    };
  }

  const hoy = moment();
  const vencimiento = moment(fechaVencimiento);
  const diasRestantes = vencimiento.diff(hoy, 'days');

  if (diasRestantes < 0) {
    // Vencida
    return {
      label: 'Vencida',
      variant: 'danger',
      color: '#dc3545',
      categoria: 'vencida'
    };
  } else if (diasRestantes <= 30) {
    // Este mes (vence en 30 días o menos)
    return {
      label: 'Este mes',
      variant: 'warning',
      color: '#ffc107',
      categoria: 'este_mes'
    };
  } else if (diasRestantes <= 60) {
    // Menos de 1 mes (vence entre 31-60 días)
    return {
      label: 'Próximo mes',
      variant: 'info',
      color: '#0dcaf0',
      categoria: 'menos_1_mes'
    };
  } else if (diasRestantes <= 90) {
    // 1 a 3 meses (vence entre 61-90 días)
    return {
      label: '1-3 meses',
      variant: 'primary',
      color: '#0d6efd',
      categoria: '1_a_3_meses'
    };
  } else {
    // Al día (vence en más de 90 días)
    return {
      label: 'Al día',
      variant: 'success',
      color: '#198754',
      categoria: 'al_dia'
    };
  }
};

/**
 * Obtiene el texto descriptivo de días restantes
 * @param {string} fechaVencimiento - Fecha de vencimiento en formato ISO
 * @returns {string} Texto descriptivo
 */
export const getDiasRestantesTexto = (fechaVencimiento) => {
  if (!fechaVencimiento) return 'Sin fecha';

  const hoy = moment();
  const vencimiento = moment(fechaVencimiento);
  const diasRestantes = vencimiento.diff(hoy, 'days');

  if (diasRestantes < 0) {
    const diasVencidos = Math.abs(diasRestantes);
    return `Vencida hace ${diasVencidos} día${diasVencidos !== 1 ? 's' : ''}`;
  } else if (diasRestantes === 0) {
    return 'Vence hoy';
  } else if (diasRestantes === 1) {
    return 'Vence mañana';
  } else {
    return `${diasRestantes} días restantes`;
  }
};
